import { useTranslation } from 'react-i18next'
import NextLink from 'next/link'
import { Button } from 'settle-ui/components/Button/Button'
import { RouterPage } from 'lib/navigation/consts'
import { logEvent } from 'lib/tracking/segment'
import { getURLSearch } from 'lib/navigation/helpers/getURLSearch/getURLSearch'
import * as events from '../../LoginPage.events'

interface ForgotPasswordLinkProps {
  email: string
}

export const ForgotPasswordLink: Settle.FC<ForgotPasswordLinkProps> = ({ email }) => {
  const { t } = useTranslation()
  const handleClick = () => logEvent(events.FORGOT_PASSWORD_LINK_CLICK)
  // `|| null` so a blank field is dropped rather than sent as `?email=`, which the reset page would
  // then have to strip back out of the URL.
  const search = getURLSearch({ email: email || null })
  const href = search ? `${RouterPage.forgotPassword}?${search}` : RouterPage.forgotPassword

  return (
    <Button component={NextLink} variant="tertiary" fullWidth={true} onClick={handleClick} href={href}>
      {t('forgotPassword')}
    </Button>
  )
}
